import React, { Component } from 'react';
import { Container, Row, Col, Image, Dropdown, Form, Button, Alert } from 'react-bootstrap';
import { QRCode } from 'react-qrcode-logo';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import CopyClipboard from '../assets/copy-clip.png';

const CryptoMethod = ({new_address, loading, coin, networks, amount_coin, addNotification, handleNetworkOnChange, translations}) => {
  let display_address = (coin == 'xrp')? new_address.split(':')[0] : new_address
  let tag_id = new_address.split(':')[1]
  return(
    <>
      <p className='dark-text medium-dms bmargin0'>{translations.checkout.crypto_payment.title}</p>
      <p className='gray-text normal-dms'>{translations.checkout.crypto_payment.instructions}</p>
      { networks[coin] &&
        <Form.Group as={Row}>
          <Form.Label column sm="2" className='dark-text medium-dms bmargin0'>
            {translations.checkout.crypto_payment.crypto_method_name}:
          </Form.Label>
          <Col sm="10">
            <Form.Control
              onChange={(e) => {handleNetworkOnChange(e.target.value)}}
              as="select"
              aria-label="Default select example"
            >
              <option key="0" value="">
                ------
              </option>
              {networks[coin] &&
                networks[coin].length > 0 &&
                networks[coin].map((option, index) => (
                  <option key={index} value={option.net}>
                    {option.name}
                  </option>
                ))}
            </Form.Control>
          </Col>
        </Form.Group>
      }

      { display_address && !loading &&
        <>
          <p className='dark-text medium-dms bmargin0'>{translations.checkout.crypto_payment.address_title}</p>
          <CopyToClipboard text={display_address}>
            <p id="ecomm-that" className='gray-text normal-dms pointer copy-btn' onClick={addNotification}>
              { display_address }
              <Image style={{height:23, marginTop:1, marginLeft:10}} src={CopyClipboard}/>
            </p>
          </CopyToClipboard>
          <div style={{textAlign:'center'}}>
            <QRCode
              bgColor="#FFFFFF"
              fgColor="#0F4C81"
              ecLevel="M"
              style={{ width: 150, margin:'auto'}}
              value={display_address}
              logoWidth={70}
              logoOpacity={0.3}
              logoImage={require("../../../CryptoIcons/" + coin + ".svg")}
              qrStyle={"dots"}
            />
          </div>
          {
            coin == 'xrp' &&
            <>
              <p className='dark-text medium-dms bmargin0'>{translations.checkout.crypto_payment.tag_id}</p>
              <CopyToClipboard text={tag_id}>
                <p id="ecomm-that" className='gray-text normal-dms pointer copy-btn' onClick={addNotification}>
                  { tag_id }
                  <Image style={{height:23, marginTop:1, marginLeft:10}} src={CopyClipboard}/>
                </p>
              </CopyToClipboard>
              <div style={{textAlign:'center'}}>
                <QRCode
                  bgColor="#FFFFFF"
                  fgColor="#0F4C81"
                  ecLevel="M"
                  style={{ width: 150, margin:'auto'}}
                  value={tag_id}
                  logoWidth={70}
                  logoOpacity={0.3}
                  logoImage={require("../../../CryptoIcons/" + coin + ".svg")}
                  qrStyle={"dots"}
                />
              </div>
            </>
          }
        </>
      }
      {
        amount_coin &&
        <>
          <p className='dark-text medium-dms bmargin0'>{translations.checkout.crypto_payment.coin_amount}</p>
          <CopyToClipboard text={amount_coin}>
            <p id="ecomm-that" className='gray-text normal-dms pointer copy-btn' onClick={addNotification}>
              {amount_coin} {coin.toUpperCase()}
              <Image style={{height:23, marginTop:1, marginLeft:10}} src={CopyClipboard}/>
            </p>
          </CopyToClipboard>
          <Alert variant='warning'>
          {translations.checkout.crypto_payment.warning}
          </Alert>
        </>
      }
    </>
  )
}
export default CryptoMethod;
